import * as angular from 'angular';
import * as layoutWithSidebar from './layout-with-sidebar';
import * as unauthenticatedLayout from 'common/source/layouts/unauthenticated';

export const module = angular.module('customerPortalLayouts', [
    layoutWithSidebar.module.name,
    unauthenticatedLayout.module.name
]);

export const layouts = {
    layoutWithSidebar: layoutWithSidebar,
    unauthenticatedLayout: unauthenticatedLayout
};
